module.exports = __webpack_public_path__ + "img/question.9bc7283c.svg";